import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { AppConstant } from '../class/app-constant';



@Directive({
  selector: '[imageLoad]'
})
export class ImageLoadDirective {
  @Input('imageLoad') public imgType: string | any;
  constructor(private renderer: Renderer2,
    private el: ElementRef) {
    this.el.nativeElement.classList.add('loading');
  }

  @HostListener('load') onLoad() {
    this.el.nativeElement.classList.remove('loading');
  }

  @HostListener('error') onError() {
    let defaultImageUrl = AppConstant.DEFAULT_PROFILE_IMAGE;
    if (this.imgType == 'group') {
      defaultImageUrl = AppConstant.DEFAULT_GROUP_IMAGE_URL;
    } else if (this.imgType == 'logo') {
      defaultImageUrl = AppConstant.DEFAULT_LOGO_IMAGE_URL;
    }
    this.renderer.setAttribute(this.el.nativeElement, 'src', defaultImageUrl);
    this.el.nativeElement.classList.remove('loading');
  }


}
